function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext, AccordionContext } from "../index";
import Loader from "./../Loader/Loader";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { Field, Form, Formik } from "formik";
import "./ShiftTime.css";
import { SHIFT_USER_LISTING_QUERY, ADD_SHIFT_MUTATION, GET_SHIFT_DETAILS_QUERY, GET_SHIFT_MODAL_DETAILS_QUERY, DELETE_SHIFT_MUTATION, EDIT_SHIFT_MUTATION, GET_SHIFT_MODAL_DETAILS_EXPORT_QUERY, GET_SHIFT_MODAL_DETAILS_HEADER_QUERY } from "./query";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import classNames from "classnames";
import * as Yup from "yup";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import "rc-time-picker/assets/index.css";
import TimePicker from "rc-time-picker";
import Table from "react-bootstrap/Table";
import { toast } from "react-toastify";
import Dropdown from "react-bootstrap/Dropdown";
import { MdInfo } from "react-icons/md";
import { HiDownload, HiOutlineDotsVertical } from "react-icons/hi";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { PlanUpgradeMessage } from "./../WorkLoadAnalysisReport/WorkLoadAnalysisReport";
import { MultiSelect } from "react-multi-select-component";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import Popover from "react-bootstrap/Popover";
import { TimeFilter } from "./../ProjectReport/DateFilter";
import { arrayToStringOutput, startOfDayCheck, endOfDayCheck } from "./../SideMenu/Header";
import DatePicker from "react-datepicker";
var LIMIT = 15;
var USER_LIMIT = 1;
var offsets = 0;
var LIST_LIMIT = 20;
var listOffsets = 0;
var shiftSchema = Yup.object().shape({
  shiftName: Yup.string().trim().required("Required")
  // shiftMembers: Yup.array().of(Yup.string()).min(1, "Required atleast 1 option").required("Required atleast 1 option"),
});
var ShiftTime = function ShiftTime(props) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    addShiftModalShow = _React$useState2[0],
    setAddShiftModalShow = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    showShiftModal = _React$useState4[0],
    setShowShiftModal = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    showDeleteModal = _React$useState6[0],
    setShowDeleteModal = _React$useState6[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    sD = _React$useContext.startDate,
    eD = _React$useContext.endDate,
    organisationStatus = _React$useContext.organisationStatus,
    organisationUserCount = _React$useContext.organisationUserCount;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var Link = props.linkComponent,
    linkProps = props.linkProps;
  var _useQuery = useQuery(SHIFT_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    usersOptionsData = _useQuery.data,
    usersOptionsError = _useQuery.error,
    usersOptionsLoading = _useQuery.loading;
  if (usersOptionsLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (usersOptionsError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!usersOptionsData) {
    return null;
  }
  var handleShow = function handleShow(modalType, shiftId, shiftName, memberIds, usersOptionsData, startTimeTimestamp, endTimeTimestamp, userMemberList) {
    var temp = {
      modalType: modalType,
      shiftId: shiftId,
      shiftName: shiftName,
      memberIds: memberIds,
      usersOptionsData: usersOptionsData,
      startTimeTimestamp: startTimeTimestamp,
      endTimeTimestamp: endTimeTimestamp,
      userMemberList: userMemberList
    };
    setAddShiftModalShow(temp);
  };
  var handleClose = function handleClose() {
    setAddShiftModalShow(null);
  };
  var handleShowShiftDetails = function handleShowShiftDetails(list) {
    offsets = 0;
    setShowShiftModal(list);
  };
  var handleCloseShiftDetails = function handleCloseShiftDetails() {
    offsets = 0;
    setShowShiftModal(null);
  };
  var handleDeleteClose = function handleDeleteClose() {
    setShowDeleteModal(null);
  };
  var handleDeleteShow = function handleDeleteShow(shiftId, organisationId, shiftName) {
    var temp = {
      shiftId: shiftId,
      organisationId: organisationId,
      shiftName: shiftName
    };
    setShowDeleteModal(temp);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "shift-time-root"
  }, organisationBilling.planName != "free" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "add-shift-time-button"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "font-weight-bold shift-time-button",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleShow("AddShift", null, null, null, usersOptionsData, null, null, null);
    }
  }, "Create New Shift")), /*#__PURE__*/React.createElement(ShiftList, {
    handleShowShiftDetails: handleShowShiftDetails,
    organisationId: organisationId,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    handleShow: handleShow,
    role: role,
    teamId: teamId,
    handleDeleteShow: handleDeleteShow,
    usersOptionsData: usersOptionsData,
    location: props.location.key
  })) : /*#__PURE__*/React.createElement(PlanUpgradeMessage, {
    displayName: user.displayName,
    history: props === null || props === void 0 ? void 0 : props.history
  }), /*#__PURE__*/React.createElement(AddShiftModal, {
    addShiftModalShow: addShiftModalShow,
    handleClose: handleClose,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    role: role,
    teamId: teamId,
    organisationId: organisationId
  }), /*#__PURE__*/React.createElement(ShiftDetailsModal, {
    showShiftModal: showShiftModal,
    handleCloseShiftDetails: handleCloseShiftDetails,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    role: role,
    teamId: teamId,
    organisationId: organisationId,
    organisationBilling: organisationBilling,
    Link: Link,
    linkProps: linkProps,
    organisationSettings: organisationSettings,
    organisationUserCount: organisationUserCount
  }), /*#__PURE__*/React.createElement(DeleteShiftModal, {
    showDeleteModal: showDeleteModal,
    handleDeleteClose: handleDeleteClose,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    role: role,
    teamId: teamId
  }));
};
var ShiftList = function ShiftList(props) {
  var _shiftTimeData$getShi, _shiftTimeData$getShi2, _shiftTimeData$getShi3, _shiftTimeData$getShi4, _shiftTimeData$getShi5;
  var handleShowShiftDetails = props.handleShowShiftDetails,
    organisationId = props.organisationId,
    timeZone = props.timeZone,
    handleShow = props.handleShow,
    role = props.role,
    teamId = props.teamId,
    handleDeleteShow = props.handleDeleteShow,
    usersOptionsData = props.usersOptionsData,
    location = props.location;

  //loadmore
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isAllLoaded = _React$useState8[0],
    setIsAllLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadingMore = _React$useState10[0],
    setIsLoadingMore = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isLoadMoreButton = _React$useState12[0],
    setIsLoadMoreButton = _React$useState12[1];
  var _useQuery2 = useQuery(GET_SHIFT_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: timeZone,
        limit: LIST_LIMIT,
        offset: 0
      },
      skip: !organisationId
    }),
    shiftTimeData = _useQuery2.data,
    shiftTimeError = _useQuery2.error,
    shiftTimeLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore,
    shiftTimeRefetch = _useQuery2.refetch;
  React.useEffect(function () {
    shiftTimeRefetch === null || shiftTimeRefetch === void 0 ? void 0 : shiftTimeRefetch();
  }, [location]);
  if ((shiftTimeData === null || shiftTimeData === void 0 ? void 0 : (_shiftTimeData$getShi = shiftTimeData.getShiftListing) === null || _shiftTimeData$getShi === void 0 ? void 0 : _shiftTimeData$getShi.length) !== 0 && (shiftTimeData === null || shiftTimeData === void 0 ? void 0 : (_shiftTimeData$getShi2 = shiftTimeData.getShiftListing) === null || _shiftTimeData$getShi2 === void 0 ? void 0 : _shiftTimeData$getShi2.length) < LIST_LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  var handleLoadMore = function handleLoadMore() {
    if (shiftTimeLoading) return;
    setIsLoadingMore(true);
    listOffsets = listOffsets + 1;
    fetchMore({
      variables: {
        offset: listOffsets * LIST_LIMIT
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$getS, _fetchMoreResult$getS2;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getS = fetchMoreResult.getShiftListing) === null || _fetchMoreResult$getS === void 0 ? void 0 : _fetchMoreResult$getS.length) === 0 && ((_fetchMoreResult$getS2 = fetchMoreResult.getShiftListing) === null || _fetchMoreResult$getS2 === void 0 ? void 0 : _fetchMoreResult$getS2.length) < LIST_LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getShiftListing: [].concat(_toConsumableArray(prev.getShiftListing), _toConsumableArray(fetchMoreResult.getShiftListing))
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, shiftTimeLoading ? /*#__PURE__*/React.createElement(Loader, null) : shiftTimeError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : shiftTimeData !== null && shiftTimeData !== void 0 && (_shiftTimeData$getShi3 = shiftTimeData.getShiftListing) !== null && _shiftTimeData$getShi3 !== void 0 && _shiftTimeData$getShi3.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "shift-time-card-root"
  }, shiftTimeData === null || shiftTimeData === void 0 ? void 0 : (_shiftTimeData$getShi4 = shiftTimeData.getShiftListing) === null || _shiftTimeData$getShi4 === void 0 ? void 0 : _shiftTimeData$getShi4.map(function (cardValue, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "position-relative shift-time-div-wrapper",
      key: cardValue.shiftId
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("shift-time-card d-block  white")
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center shift-time-name-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "shift-time-card-avatar",
      onClick: function onClick(e) {
        return handleShowShiftDetails({
          shiftId: cardValue.shiftId,
          shiftName: cardValue.shiftName,
          startTime: cardValue.startTime,
          endTime: cardValue.endTime,
          totalMembers: cardValue.totalMembers,
          activeMembers: cardValue.activeMembers,
          startTimeTimestamp: cardValue.startTimeTimestamp,
          endTimeTimestamp: cardValue.endTimeTimestamp
        });
      }
    }, cardValue.shiftName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement(OverlayTrigger, {
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-project-name"
      }, cardValue.shiftName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "shift-time-card-name flex-grow-1",
      onClick: function onClick(e) {
        return handleShowShiftDetails({
          shiftId: cardValue.shiftId,
          shiftName: cardValue.shiftName,
          startTime: cardValue.startTime,
          endTime: cardValue.endTime,
          totalMembers: cardValue.totalMembers,
          activeMembers: cardValue.activeMembers,
          startTimeTimestamp: cardValue.startTimeTimestamp,
          endTimeTimestamp: cardValue.endTimeTimestamp
        });
      }
    }, cardValue.shiftName)), /*#__PURE__*/React.createElement("div", {
      "class": "shift-time-card-percentage"
    }, /*#__PURE__*/React.createElement(EditMenuIcon, {
      organisationId: organisationId,
      handleShow: handleShow,
      handleDeleteShow: handleDeleteShow,
      shiftId: cardValue.shiftId,
      shiftName: cardValue.shiftName,
      memberIds: cardValue.memberIds,
      usersOptionsData: usersOptionsData,
      startTimeTimestamp: cardValue.startTimeTimestamp,
      endTimeTimestamp: cardValue.endTimeTimestamp,
      userMemberList: cardValue.userMemberList
    }))), /*#__PURE__*/React.createElement("div", {
      className: "shift-time-wrapper-div",
      onClick: function onClick(e) {
        return handleShowShiftDetails({
          shiftId: cardValue.shiftId,
          shiftName: cardValue.shiftName,
          startTime: cardValue.startTime,
          endTime: cardValue.endTime,
          totalMembers: cardValue.totalMembers,
          activeMembers: cardValue.activeMembers,
          startTimeTimestamp: cardValue.startTimeTimestamp,
          endTimeTimestamp: cardValue.endTimeTimestamp
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "shift-time-card-body"
    }, /*#__PURE__*/React.createElement("p", {
      className: "shift-time-card-body-text"
    }, "Shift Time: ", cardValue.startTime, " to ", cardValue.endTime)), /*#__PURE__*/React.createElement("div", {
      className: "shift-time-card-footer"
    }, /*#__PURE__*/React.createElement("p", {
      className: "shift-time-card-footer-text"
    }, "Currently active ", cardValue.activeMembers, " members", " ", /*#__PURE__*/React.createElement("span", {
      className: "shift-time-card-footer-text-gray"
    }, "out of ", cardValue.totalMembers, " "))))));
  })), shiftTimeData !== null && shiftTimeData !== void 0 && (_shiftTimeData$getShi5 = shiftTimeData.getShiftListing) !== null && _shiftTimeData$getShi5 !== void 0 && _shiftTimeData$getShi5.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : null
  // (
  //   <p className="screenshot-load-more-button">You have seen all the data</p>
  // )
  ) : null) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button shift-detail-miled-text"
  }, "Yet to create a shift."));
};
var EditMenuIcon = function EditMenuIcon(props) {
  var handleShow = props.handleShow,
    handleDeleteShow = props.handleDeleteShow,
    shiftId = props.shiftId,
    shiftName = props.shiftName,
    organisationId = props.organisationId,
    memberIds = props.memberIds,
    usersOptionsData = props.usersOptionsData,
    startTimeTimestamp = props.startTimeTimestamp,
    endTimeTimestamp = props.endTimeTimestamp,
    userMemberList = props.userMemberList;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "shift-time-card-edit-menus"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(HiOutlineDotsVertical, {
    className: "shift-time-card-edit-menus-icon"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleShow("EditShift", shiftId, shiftName, memberIds, usersOptionsData, startTimeTimestamp, endTimeTimestamp, userMemberList);
    }
  }, "Edit"), /*#__PURE__*/React.createElement(Dropdown.Divider, null), /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "manage-teams-edit-menus-delete-icon",
    onClick: function onClick() {
      return handleDeleteShow(shiftId, organisationId, shiftName);
    }
  }, "Delete Shift"))));
};
var ShiftDetailsModal = function ShiftDetailsModal(props) {
  var showShiftModal = props.showShiftModal,
    handleCloseShiftDetails = props.handleCloseShiftDetails,
    timeZone = props.timeZone,
    role = props.role,
    teamId = props.teamId,
    organisationId = props.organisationId,
    organisationBilling = props.organisationBilling,
    Link = props.Link,
    linkProps = props.linkProps,
    organisationSettings = props.organisationSettings,
    organisationUserCount = props.organisationUserCount;
  if (showShiftModal === null) {
    return null;
  }
  var shiftId = showShiftModal.shiftId,
    shiftName = showShiftModal.shiftName,
    startTime = showShiftModal.startTime,
    endTime = showShiftModal.endTime,
    totalMembers = showShiftModal.totalMembers,
    activeMembers = showShiftModal.activeMembers,
    startTimeTimestamp = showShiftModal.startTimeTimestamp,
    endTimeTimestamp = showShiftModal.endTimeTimestamp;

  //const [startDate, setStartDate] = React.useState(new Date());
  // const [dates, setDate] = React.useState({
  //   startDate: startOfDayCheck(currentTimezone, organisationSettings?.organisationTimezone)
  //     ? moment().tz(currentTimezone).clone().startOf("day").toDate()
  //     : endOfDayCheck(currentTimezone, organisationSettings?.organisationTimezone)
  //     ? moment().tz(currentTimezone).clone().endOf("days").toDate()
  //     : moment().tz(currentTimezone).clone().toDate(),
  //   endDate: null,
  // });

  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var _React$useState13 = React.useState(startOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().startOf("day").toDate() : endOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().endOf("days").toDate() : moment().tz(currentTimezone).clone().toDate()),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    startDate = _React$useState14[0],
    setStartDate = _React$useState14[1];

  //loadmore
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isAllLoaded = _React$useState16[0],
    setIsAllLoaded = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isLoadingMore = _React$useState18[0],
    setIsLoadingMore = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    exportButton = _React$useState20[0],
    setExportButton = _React$useState20[1];

  // const { startDate, endDate } = dates;
  var _React$useState21 = React.useState(arrayToStringOutput([startDate, startDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    filterData = _React$useState22[0],
    setFilterData = _React$useState22[1];
  React.useEffect(function () {
    offsets = 0;
  }, [startDate]);
  var startTimeArr = startTime.split(" ");
  var endTimeArr = endTime.split(" ");
  var loopCount = 0;
  var startDayDate = moment(startDate).tz(timeZone).startOf("day");
  var endDayDate = moment(startDate).tz(timeZone).startOf("day");
  var daysDiff = endDayDate.diff(startDayDate, "days");
  var dateArrStart = [];
  var dateArrEnd = [];
  for (var loopingDate = startDayDate; loopingDate <= endDayDate; loopingDate = moment(loopingDate).add(1, "days").startOf("day")) {
    if (loopCount <= daysDiff) {
      var startDateLoop = moment(loopingDate).tz(timeZone).format("DD/MM/YYYY");
      var startDateFormate = startDateLoop;
      var endDateFormate = startDateLoop;
      if (startTimeArr[1] == "PM" && endTimeArr[1] == "AM") {
        endDateFormate = moment(startDateLoop).tz(timeZone).add(1, "days").format("DD/MM/YYYY");
      }
      var startTimeFormateTemp = moment(startDateFormate + " " + startTime, "DD/MM/YYYY HH:mm A").valueOf();
      var endTimeFormateTemp = moment(endDateFormate + " " + endTime, "DD/MM/YYYY HH:mm A").valueOf();
      if (startTimeArr[1] == "AM" && endTimeArr[1] == "AM" && moment(startTimeFormateTemp).valueOf() > moment(endTimeFormateTemp).valueOf()) {
        endDateFormate = moment(startDateLoop).tz(timeZone).add(1, "days").format("DD/MM/YYYY");
        endTimeFormateTemp = moment(endDateFormate + " " + endTime, "DD/MM/YYYY HH:mm A").valueOf();
      } else if (startTimeArr[1] == "PM" && endTimeArr[1] == "PM" && moment(startTimeFormateTemp).valueOf() > moment(endTimeFormateTemp).valueOf()) {
        endDateFormate = moment(startDateLoop).tz(timeZone).add(1, "days").format("DD/MM/YYYY");
        endTimeFormateTemp = moment(endDateFormate + " " + endTime, "DD/MM/YYYY HH:mm A").valueOf();
      }
      dateArrStart.push(startTimeFormateTemp);
      dateArrEnd.push(endTimeFormateTemp);
    } else {
      return;
    }
    loopCount++;
  }

  // const {
  //   data: headerDatas,
  //   error: headerError,
  //   loading: headerLoading,
  // } = useQuery(GET_SHIFT_MODAL_DETAILS_HEADER_QUERY, {
  //   variables: {
  //     organisationId,
  //     startDate: Number(moment(startDate).format("x")),
  //     endDate: Number(moment(endDate ?? startDate).format("x")),
  //     timeZone,
  //     shiftId,
  //     startTime: startTime,
  //     endTime: endTime,
  //     startTimeFormate: dateArrStart,
  //     endTimeFormate: dateArrEnd,
  //   },
  //   skip: !organisationId,
  // });

  var onFilterChange = function onFilterChange(dates) {
    setDate(dates);
  };
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: showShiftModal,
    onHide: handleCloseShiftDetails,
    centered: true,
    dialogClassName: "modal-90w",
    "aria-labelledby": "example-custom-modal-styling-title",
    className: "project-detail-task-detail-modal",
    backdrop: "static"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-detail-task-detail-modal-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "shift-modal-title"
  }, shiftName)), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-detail-task-detail-edit-modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-time-details-modals-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-time-details-modals-header"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "shift-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-manual-task-details-card-title text-dark"
  }, "Shift Time"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, startTime, " to ", endTime)), /*#__PURE__*/React.createElement("div", {
    "class": "shift-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-manual-task-details-card-title text-dark"
  }, "Members in Shift"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, totalMembers))), /*#__PURE__*/React.createElement(ShiftDetailsTable, {
    organisationId: organisationId,
    timeZone: timeZone,
    organisationBilling: organisationBilling,
    shiftId: shiftId,
    startTime: startTime,
    endTime: endTime,
    shiftName: shiftName,
    startTimeTimestamp: startTimeTimestamp,
    endTimeTimestamp: endTimeTimestamp,
    startDate: startDate,
    setStartDate: setStartDate,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    exportButton: exportButton,
    setExportButton: setExportButton,
    Link: Link,
    linkProps: linkProps,
    startTimeFormateTemp: dateArrStart,
    endTimeFormateTemp: dateArrEnd,
    onFilterChange: onFilterChange
    // startDate={startDate}
    // endDate={endDate}
    ,
    filterData: filterData,
    hideOverlay: hideOverlay,
    organisationSettings: organisationSettings,
    shiftTotalMembers: totalMembers
  }))));
};
var ShiftDetailsTable = function ShiftDetailsTable(props) {
  var _usersDatas$getShiftT4, _usersDatas$getShiftT5;
  var organisationId = props.organisationId,
    timeZone = props.timeZone,
    organisationBilling = props.organisationBilling,
    shiftId = props.shiftId,
    startTime = props.startTime,
    endTime = props.endTime,
    shiftName = props.shiftName,
    endTimeTimestamp = props.endTimeTimestamp,
    startTimeTimestamp = props.startTimeTimestamp,
    startDate = props.startDate,
    setStartDate = props.setStartDate,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    exportButton = props.exportButton,
    setExportButton = props.setExportButton,
    Link = props.Link,
    linkProps = props.linkProps,
    startTimeFormateTemp = props.startTimeFormateTemp,
    endTimeFormateTemp = props.endTimeFormateTemp,
    onFilterChange = props.onFilterChange,
    filterData = props.filterData,
    hideOverlay = props.hideOverlay,
    organisationSettings = props.organisationSettings,
    shiftTotalMembers = props.shiftTotalMembers;
  var daysDiff = moment(startDate !== null && startDate !== void 0 ? startDate : startDate).diff(moment(startDate), "days");
  var _React$useState23 = React.useState([]),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    allUsers = _React$useState24[0],
    setAllUsers = _React$useState24[1];
  var exportLimit = 30;
  var exportOffsets = 0;
  var totalUserCount = Number(shiftTotalMembers); // Assume 300 users

  var _React$useState25 = React.useState(0),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    loopInit = _React$useState26[0],
    setLoopInit = _React$useState26[1];

  // let loopInit = 0;
  var loopCount = Number(Math.ceil(shiftTotalMembers / exportLimit)) + 1;

  // console.log({ loopCount });
  // console.log({ loopInit });

  React.useEffect(function () {
    setLoopInit(0);
    exportOffsets = 0;
    setAllUsers([]);
  }, [startDate]);
  var _useQuery3 = useQuery(GET_SHIFT_MODAL_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(startDate).format("x")),
        timeZone: timeZone,
        limit: daysDiff < 3 ? LIMIT : USER_LIMIT,
        offset: 0,
        shiftId: shiftId,
        startTime: startTime,
        endTime: endTime,
        startTimeFormate: startTimeFormateTemp,
        endTimeFormate: endTimeFormateTemp
      },
      skip: !organisationId
    }),
    usersDatas = _useQuery3.data,
    usersError = _useQuery3.error,
    usersLoading = _useQuery3.loading,
    fetchMore = _useQuery3.fetchMore;
  var _useLazyQuery = useLazyQuery(GET_SHIFT_MODAL_DETAILS_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  React.useEffect(function () {
    var _usersDatas$getShiftT, _usersDatas$getShiftT2, _usersDatas$getShiftT3;
    setIsAllLoaded((usersDatas === null || usersDatas === void 0 ? void 0 : (_usersDatas$getShiftT = usersDatas.getShiftTimeDetails) === null || _usersDatas$getShiftT === void 0 ? void 0 : _usersDatas$getShiftT.length) != 0 && (usersDatas === null || usersDatas === void 0 ? void 0 : (_usersDatas$getShiftT2 = usersDatas.getShiftTimeDetails) === null || _usersDatas$getShiftT2 === void 0 ? void 0 : _usersDatas$getShiftT2.length) < (daysDiff < 3 ? LIMIT : USER_LIMIT) && daysDiff < 3 || (usersDatas === null || usersDatas === void 0 ? void 0 : (_usersDatas$getShiftT3 = usersDatas.getShiftTimeDetails) === null || _usersDatas$getShiftT3 === void 0 ? void 0 : _usersDatas$getShiftT3.length) == 0 && daysDiff >= 3 ? true : false);
  }, [usersDatas]);
  React.useEffect(function () {
    // console.log("use effect enter");
    // console.log({ loopInit: exportData });

    if (exportData !== null && exportData !== void 0 && exportData.getShiftTimeDetailsExport && exportButton) {
      var dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.getShiftTimeDetailsExport;
      // console.log({ dataValues });
      if (!dataValues) {
        return [];
      }
      setAllUsers(function (prevUsers) {
        return [].concat(_toConsumableArray(prevUsers), _toConsumableArray(dataValues));
      });
      // console.log({ allUsers });
      // console.log({ loopInit, loopCount });

      if (loopInit <= loopCount) {
        exportOffsets = loopInit * exportLimit;
        setLoopInit(loopInit + 1);
        getExport({
          variables: {
            organisationId: organisationId,
            startDate: Number(moment(startDate).format("x")),
            endDate: Number(moment(startDate).format("x")),
            timeZone: timeZone,
            shiftId: shiftId,
            startTime: startTime,
            endTime: endTime,
            startTimeFormate: startTimeFormateTemp,
            endTimeFormate: endTimeFormateTemp,
            limit: exportLimit,
            offset: exportOffsets
          }
        });
      }

      // console.log({ allUsers: allUsers.length, totalUserCount });

      if (allUsers.length && loopInit == loopCount) {
        // console.log("if enter");
        // console.log({ allUsers });
        xlsxData(allUsers);
      }
    }
  }, [exportData]);
  var handleLoadMore = function handleLoadMore() {
    if (usersLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * (daysDiff < 3 ? LIMIT : USER_LIMIT)
      },
      updateQuery: function updateQuery(prev, _ref2) {
        var _fetchMoreResult$getS3, _fetchMoreResult$getS4;
        var fetchMoreResult = _ref2.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getS3 = fetchMoreResult.getShiftTimeDetails) === null || _fetchMoreResult$getS3 === void 0 ? void 0 : _fetchMoreResult$getS3.length) === 0 && ((_fetchMoreResult$getS4 = fetchMoreResult.getShiftTimeDetails) === null || _fetchMoreResult$getS4 === void 0 ? void 0 : _fetchMoreResult$getS4.length) < (daysDiff < 3 ? LIMIT : USER_LIMIT) && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getShiftTimeDetails: [].concat(_toConsumableArray(prev.getShiftTimeDetails), _toConsumableArray(fetchMoreResult.getShiftTimeDetails))
        });
      }
    });
  };
  var xlsxData = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(allUsers) {
      var wb, ws, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (allUsers) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", []);
          case 2:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            ws.columns = [{
              header: "Employee Name",
              key: "displayName",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Date",
              key: "date",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Worked Time in Shift",
              key: "workedTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Active Time in Shift",
              key: "activeTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Shift Started",
              key: "clockIn",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Shift Ended",
              key: "clockOut",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Shift Work Status",
              key: "endStatus",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            allUsers.map(function (users, index) {
              var userId = users.userId,
                displayName = users.displayName,
                profileUrl = users.profileUrl,
                workedTime = users.workedTime,
                clockIn = users.clockIn,
                clockOut = users.clockOut,
                activeTime = users.activeTime,
                totalSec = users.totalSec,
                endStatus = users.endStatus,
                date = users.date;
              ws.addRow({
                displayName: displayName,
                clockIn: Number(totalSec) == 0 ? "-" : clockIn,
                clockOut: Number(totalSec) == 0 || clockOut == null ? "-" : clockOut && clockOut == "Working On" ? "-" : clockOut && clockOut == "break" ? "-" : clockOut,
                workedTime: workedTime,
                activeTime: activeTime,
                endStatus: endStatus,
                date: moment(Number(date)).format("DD MMM YYYY")
              });
            });
            ws.getCell("A1").font = {
              bold: true
            };
            ws.getCell("B1").font = {
              bold: true
            };
            ws.getCell("C1").font = {
              bold: true
            };
            ws.getCell("D1").font = {
              bold: true
            };
            ws.getCell("E1").font = {
              bold: true
            };
            ws.getCell("F1").font = {
              bold: true
            };
            _context.next = 14;
            return wb.xlsx.writeBuffer();
          case 14:
            buf = _context.sent;
            fileName = "".concat(shiftName, "-").concat(moment(Number(startDate)).format("DD-MMM"), ".xlsx"); // if (endDate != null) {
            //   fileName = `${shiftName}-${moment(Number(startDate)).format("DD-MMM")}-${moment(Number(endDate)).format(
            //     "DD-MMM"
            //   )}.xlsx`;
            // }
            saveAs(new Blob([buf]), fileName);
            setExportButton(false);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function xlsxData(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getExportData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setExportButton(true);

            // let loopInit = 0;
            // let loopCount = Math.round(totalUserCount / exportLimit);

            // console.log({ loopInit, loopCount });
            // console.log({ exportLimit, exportOffsets });

            // && (loopInit == 0 || (loopInit > 0 && exportData)

            // while (loopInit <= loopCount) {
            setLoopInit(loopInit + 1);

            // console.log({ export: loopInit });

            getExport({
              variables: {
                organisationId: organisationId,
                startDate: Number(moment(startDate).format("x")),
                endDate: Number(moment(startDate).format("x")),
                timeZone: timeZone,
                shiftId: shiftId,
                startTime: startTime,
                endTime: endTime,
                startTimeFormate: startTimeFormateTemp,
                endTimeFormate: endTimeFormateTemp,
                limit: exportLimit,
                offset: exportOffsets
              }
            });
            // }
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getExportData() {
      return _ref4.apply(this, arguments);
    };
  }();
  var DatePickerInput = function DatePickerInput(_ref5) {
    var value = _ref5.value,
      onClick = _ref5.onClick;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
      className: "my-input",
      type: "text",
      onClick: onClick,
      value: isToday(Number(startDate)) ? "Today" : isYesterday(Number(startDate)) ? "Yesterday" : "".concat(moment(startDate).format("DD MMM, yyyy"))
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "shift-time-modal-header-date-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-time-details-employee-list-card-heading"
  }, "Shift Timesheet"), /*#__PURE__*/React.createElement("div", {
    className: "shift-time-date-picker"
  }, /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-date-picker"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    selected: startDate,
    onChange: function onChange(date) {
      return setStartDate(date);
    },
    dateFormat: "dd MMM, yyyy",
    minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? subDays(new Date(), 14) : null
  }))), /*#__PURE__*/React.createElement("div", null, !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    },
    className: "shift-detail-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "daily-attendance-filter-download-icon-btn shift-detail-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading"))), /*#__PURE__*/React.createElement("div", {
    className: "shift-time-modal-header-date-div-text-div"
  }, /*#__PURE__*/React.createElement("p", {
    className: "shift-time-modal-header-date-div-text-div-head-mute"
  }, "The worked time between the shift only taken into the calculation. Outside work hours won't be included.")), /*#__PURE__*/React.createElement("div", {
    className: "shift-time-details-employee-list-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-time-details-employee-list-card-data"
  }, usersLoading ? /*#__PURE__*/React.createElement("div", {
    className: "shift-time-card-root-list-section-body"
  }, /*#__PURE__*/React.createElement(Loader, null)) : usersError ? /*#__PURE__*/React.createElement("div", {
    className: "shift-time-card-root-list-section-body"
  }, /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "shift-time-details-employee-list-card-data-table"
  }, /*#__PURE__*/React.createElement("tbody", null, usersDatas === null || usersDatas === void 0 ? void 0 : (_usersDatas$getShiftT4 = usersDatas.getShiftTimeDetails) === null || _usersDatas$getShiftT4 === void 0 ? void 0 : _usersDatas$getShiftT4.map(function (employeeData, key) {
    var _employeeData$display;
    return /*#__PURE__*/React.createElement(React.Fragment, null, key == 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      className: "shift-time-details-employee-list-card-data-header"
    }, /*#__PURE__*/React.createElement("th", {
      className: "shift-table-text-align"
    }, "Employee Name"), /*#__PURE__*/React.createElement("th", null, "Date"), /*#__PURE__*/React.createElement("th", null, "Worked Time in Shift", /*#__PURE__*/React.createElement("div", {
      className: "shift-detail-modal-time-div"
    }, "(", startTime, " to ", endTime, ")")), /*#__PURE__*/React.createElement("th", null, "Active Time in Shift", /*#__PURE__*/React.createElement("div", {
      className: "shift-detail-modal-time-div"
    }, "(", startTime, " to ", endTime, ")")), /*#__PURE__*/React.createElement("th", null, "Shift Started"), /*#__PURE__*/React.createElement("th", null, "Shift Ended"), /*#__PURE__*/React.createElement("th", null, "Shift Work Status"))) : null, /*#__PURE__*/React.createElement("tr", {
      className: classNames("shift-time-details-employee-list-card-details", {
        "shift-time-details-employee-list-card-details-working-on": (employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) && (employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) == "Working On"
      }, {
        "shift-time-details-employee-list-card-details-stop": (employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) && (employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) !== "Working On" && ((employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) && (employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) == "break" || Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.totalSec) !== 0 || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) !== null)
      }, {
        "shift-time-details-employee-list-card-details-internet-interrupt": (employeeData === null || employeeData === void 0 ? void 0 : employeeData.endStatus) == "Internet interrupted"
      }),
      key: key
    }, /*#__PURE__*/React.createElement("td", {
      className: "shift-table-text-align"
    }, /*#__PURE__*/React.createElement("div", {
      className: "shift-details-employee-list-card-details-avatar"
    }, (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === null || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === "" ? /*#__PURE__*/React.createElement("div", {
      className: "shift-details-card-avatar"
    }, employeeData === null || employeeData === void 0 ? void 0 : (_employeeData$display = employeeData.displayName) === null || _employeeData$display === void 0 ? void 0 : _employeeData$display.charAt(0).toUpperCase()) : /*#__PURE__*/React.createElement("div", {
      className: "shift-details-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "DeskTime",
      src: employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl,
      className: "shift-details-card-avatar-profile-img"
    })), /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(employeeData === null || employeeData === void 0 ? void 0 : employeeData.uniqueUrl)), {
      key: "recent-".concat(employeeData === null || employeeData === void 0 ? void 0 : employeeData.uniqueUrl)
    }), /*#__PURE__*/React.createElement("p", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.displayName)))), /*#__PURE__*/React.createElement("td", null, moment(Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.date)).format("DD MMM YYYY")), /*#__PURE__*/React.createElement("td", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.workedTime), /*#__PURE__*/React.createElement("td", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.activeTime), /*#__PURE__*/React.createElement("td", null, Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.totalSec) == 0 ? "-" : employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockIn), /*#__PURE__*/React.createElement("td", null, Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.totalSec) == 0 || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) == null ? "-" : employeeData !== null && employeeData !== void 0 && employeeData.clockOut && (employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) == "Working On" ? "-" : employeeData !== null && employeeData !== void 0 && employeeData.clockOut && (employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut) == "break" ? "-" : employeeData === null || employeeData === void 0 ? void 0 : employeeData.clockOut), /*#__PURE__*/React.createElement("td", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.endStatus)));
  }))), usersDatas !== null && usersDatas !== void 0 && (_usersDatas$getShiftT5 = usersDatas.getShiftTimeDetails) !== null && _usersDatas$getShiftT5 !== void 0 && _usersDatas$getShiftT5.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : null
  // (
  //   <p className="screenshot-load-more-button">You have seen all the employee</p>
  // )
  ) : null))));
};
var formats = "h:mm a";
var AddShiftModal = function AddShiftModal(props) {
  var addShiftModalShow = props.addShiftModalShow,
    handleClose = props.handleClose,
    timeZone = props.timeZone,
    role = props.role,
    teamId = props.teamId,
    organisationId = props.organisationId;
  if (addShiftModalShow === null) {
    return null;
  }
  var shiftId = addShiftModalShow.shiftId,
    shiftName = addShiftModalShow.shiftName,
    memberIds = addShiftModalShow.memberIds,
    modalType = addShiftModalShow.modalType,
    usersOptionsData = addShiftModalShow.usersOptionsData,
    startTimeTimestamp = addShiftModalShow.startTimeTimestamp,
    endTimeTimestamp = addShiftModalShow.endTimeTimestamp,
    startTimeBeforeTimestamp = addShiftModalShow.startTimeBeforeTimestamp,
    endTimeBeforeTimestamp = addShiftModalShow.endTimeBeforeTimestamp,
    userMemberList = addShiftModalShow.userMemberList;
  var _React$useState27 = React.useState(modalType == "AddShift" ? "" : startTimeTimestamp ? moment(startTimeTimestamp).format("HH:mm") : ""),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    modalStartTime = _React$useState28[0],
    setModalStartTime = _React$useState28[1];
  var _React$useState29 = React.useState(modalType == "AddShift" ? "" : endTimeTimestamp ? moment(endTimeTimestamp).format("HH:mm") : ""),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    modalEndTime = _React$useState30[0],
    setModalEndTime = _React$useState30[1];
  var _React$useState31 = React.useState(modalType == "AddShift" ? undefined : startTimeTimestamp ? moment(startTimeTimestamp) : undefined),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    modalValueStartTime = _React$useState32[0],
    setModalValueStartTime = _React$useState32[1];
  var _React$useState33 = React.useState(modalType == "AddShift" ? undefined : endTimeTimestamp ? moment(endTimeTimestamp) : undefined),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    modalValueEndTime = _React$useState34[0],
    setModalValueEndTime = _React$useState34[1];
  var _React$useState35 = React.useState(false),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    startTimeError = _React$useState36[0],
    setStartTimeError = _React$useState36[1];
  var _React$useState37 = React.useState(false),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    endTimeError = _React$useState38[0],
    setEndTimeError = _React$useState38[1];
  var _React$useState39 = React.useState(false),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    memberError = _React$useState40[0],
    setMemberError = _React$useState40[1];
  var _React$useState41 = React.useState(modalType == "AddShift" ? [] : userMemberList),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    userParameterCheck = _React$useState42[0],
    setUserParameterCheck = _React$useState42[1];
  var _React$useState43 = React.useState(modalType == "AddShift" ? [] : memberIds),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    userActive = _React$useState44[0],
    setUserActive = _React$useState44[1];
  var userList = modalType == "AddShift" ? usersOptionsData === null || usersOptionsData === void 0 ? void 0 : usersOptionsData.getShiftUserListing : [];
  var _useMutation = useMutation(ADD_SHIFT_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addShiftTime = _useMutation2[0],
    addShiftTimeLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(EDIT_SHIFT_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    editShiftTime = _useMutation4[0],
    editShiftTimeLoading = _useMutation4[1].loading;
  React.useEffect(function () {
    var selectedUserIds = userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.map(function (user) {
      return user.value;
    });
    setUserActive(selectedUserIds);
  }, [userParameterCheck]);
  var handleAddSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values) {
      var shiftName, variables, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            shiftName = values.shiftName;
            if (!(modalStartTime == "" || modalEndTime == "")) {
              _context3.next = 9;
              break;
            }
            if (!(modalStartTime == "")) {
              _context3.next = 7;
              break;
            }
            setStartTimeError(true);
            return _context3.abrupt("return", null);
          case 7:
            setEndTimeError(true);
            return _context3.abrupt("return", null);
          case 9:
            if (!(userActive.length == 0)) {
              _context3.next = 12;
              break;
            }
            setMemberError(true);
            return _context3.abrupt("return", null);
          case 12:
            variables = {
              shiftName: shiftName,
              startTime: modalStartTime,
              endTime: modalEndTime,
              organisationId: organisationId,
              timeZone: timeZone,
              shiftMembers: userActive
            };
            _context3.prev = 13;
            _context3.next = 16;
            return addShiftTime({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: SHIFT_USER_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userRole: role
                }
              }, {
                query: GET_SHIFT_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  limit: LIST_LIMIT,
                  offset: 0
                }
              }]
            });
          case 16:
            response = _context3.sent;
            if (!(!response || !response.data || response.data.addShiftTime == null)) {
              _context3.next = 21;
              break;
            }
            throw new Error("error");
          case 21:
            toast.success("Shift time added successfully!");
            handleClose();
          case 23:
            _context3.next = 27;
            break;
          case 25:
            _context3.prev = 25;
            _context3.t0 = _context3["catch"](13);
          case 27:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[13, 25]]);
    }));
    return function (_x2) {
      return _ref7.apply(this, arguments);
    };
  }(), [addShiftTime, addShiftTimeLoading, modalStartTime, modalEndTime, userActive]);
  var handleEditSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(values) {
      var shiftName, variables, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            shiftName = values.shiftName;
            if (!(modalStartTime == "" || modalEndTime == "")) {
              _context4.next = 9;
              break;
            }
            if (!(modalStartTime == "")) {
              _context4.next = 7;
              break;
            }
            setStartTimeError(true);
            return _context4.abrupt("return", null);
          case 7:
            setEndTimeError(true);
            return _context4.abrupt("return", null);
          case 9:
            if (!(userActive.length == 0)) {
              _context4.next = 12;
              break;
            }
            setMemberError(true);
            return _context4.abrupt("return", null);
          case 12:
            variables = {
              shiftName: shiftName,
              startTime: modalStartTime,
              endTime: modalEndTime,
              organisationId: organisationId,
              timeZone: timeZone,
              shiftMembers: userActive,
              shiftId: shiftId
            };
            _context4.prev = 13;
            _context4.next = 16;
            return editShiftTime({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: SHIFT_USER_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userRole: role
                }
              }, {
                query: GET_SHIFT_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  limit: LIST_LIMIT,
                  offset: 0
                }
              }]
            });
          case 16:
            response = _context4.sent;
            if (!(!response || !response.data || response.data.editShiftTime == null)) {
              _context4.next = 21;
              break;
            }
            throw new Error("error");
          case 21:
            toast.success("Shift time edited successfully!");
            handleClose();
          case 23:
            _context4.next = 27;
            break;
          case 25:
            _context4.prev = 25;
            _context4.t0 = _context4["catch"](13);
          case 27:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[13, 25]]);
    }));
    return function (_x3) {
      return _ref8.apply(this, arguments);
    };
  }(), [editShiftTime, editShiftTimeLoading, modalStartTime, modalEndTime, userActive]);
  var startOnChange = function startOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      } else {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        var sHours = "00";
        var sMinutes = minutes.toString();
        if (AMPM == "am" && hours == 12) {
          var time = sHours + ":" + sMinutes;
          finalTime = time;
        } else {
          finalTime = arrData[0];
        }
      }
      setModalValueStartTime(value);
      setModalStartTime(finalTime);
      setFieldValue("startTime", finalTime);
      setStartTimeError(false);
    } else {
      setModalStartTime("");
      setFieldValue("startTime", "");
      setStartTimeError(true);
    }
  };
  var endOnChange = function endOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      } else {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        var sHours = "00";
        var sMinutes = minutes.toString();
        if (AMPM == "am" && hours == 12) {
          var time = sHours + ":" + sMinutes;
          finalTime = time;
        } else {
          finalTime = arrData[0];
        }
      }
      setModalValueEndTime(value);
      setModalEndTime(finalTime);
      setFieldValue("endTime", finalTime);
      setEndTimeError(false);
    } else {
      setModalValueEndTime(undefined);
      setModalEndTime("");
      setFieldValue("endTime", "");
      setEndTimeError(true);
    }
  };
  if (modalType !== "AddShift") {
    var _usersOptionsData$get;
    usersOptionsData === null || usersOptionsData === void 0 ? void 0 : (_usersOptionsData$get = usersOptionsData.getShiftUserListing) === null || _usersOptionsData$get === void 0 ? void 0 : _usersOptionsData$get.map(function (item) {
      var label = item.label,
        value = item.value,
        disabled = item.disabled;
      var check = userMemberList.find(function (user) {
        return user.value === value;
      });
      var displayName = label.split("(");
      if (check) {
        userList.push({
          label: displayName[0],
          value: value,
          disabled: false
        });
      } else {
        userList.push({
          label: label,
          value: value,
          disabled: disabled
        });
      }
      return;
    });
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true,
    backdrop: "static",
    className: "my-projects-modal-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "my-projects-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "my-projects-modal-title"
  }, modalType == "AddShift" ? "New Shift Details" : "Edit Shift Details")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      shiftName: modalType == "AddShift" ? "" : shiftName
      //shiftMembers: modalType == "AddShift" ? [] : memberIds,
    },
    validationSchema: shiftSchema,
    onSubmit: modalType == "AddShift" ? handleAddSubmit : handleEditSubmit
  }, function (_ref9) {
    var setFieldValue = _ref9.setFieldValue,
      errors = _ref9.errors,
      touched = _ref9.touched,
      values = _ref9.values;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: "my-projects-modal-content-row"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "shiftName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Shift Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        placeholder: "Morning shift",
        className: "shift-time-edit-label-input"
      }, field)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "startTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "shift-start-time-modal-label-name"
      }, "Shift Start Time", " ", /*#__PURE__*/React.createElement(OverlayTrigger, {
        key: "active1-working",
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "count-tooltip-start"
        }, /*#__PURE__*/React.createElement("div", null, "Set the shift start time based on your organization timezone in workfolio"))
      }, /*#__PURE__*/React.createElement("span", {
        className: "shift-details-summary-card-text-ques"
      }, " ", /*#__PURE__*/React.createElement(MdInfo, null)))), startTimeError ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, "required") : null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "startTime",
        value: modalValueStartTime,
        className: "shift-start-time-formik-add-form",
        onChange: function onChange(e) {
          startOnChange(e, setFieldValue);
        },
        placeholder: "Start Time",
        format: formats,
        use12Hours: true,
        inputReadOnly: true
      }));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "endTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "shift-start-time-modal-label-name"
      }, "Shift End Time", " ", /*#__PURE__*/React.createElement(OverlayTrigger, {
        key: "active-working",
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "count-tooltip-start"
        }, /*#__PURE__*/React.createElement("div", null, "Set the shift end time based on your organization timezone in workfolio", " "))
      }, /*#__PURE__*/React.createElement("span", {
        className: "shift-details-summary-card-text-ques"
      }, " ", /*#__PURE__*/React.createElement(MdInfo, null)))), endTimeError ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, "required") : null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "endTime",
        value: modalValueEndTime,
        className: "shift-start-time-formik-add-form",
        onChange: function onChange(e) {
          endOnChange(e, setFieldValue);
        },
        placeholder: "End Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: undefined,
        inputReadOnly: true
      }));
    })), /*#__PURE__*/React.createElement("div", {
      className: "shift-time-filter-user"
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "my-projects-modal-label-name"
    }, "Choose Shift Members"), memberError ? /*#__PURE__*/React.createElement(ControlLabel, {
      className: "error"
    }, "required") : null, /*#__PURE__*/React.createElement(MultiSelect, {
      options: userList,
      value: userParameterCheck,
      onChange: function onChange(e) {
        setUserParameterCheck(e);
        setMemberError(false);
      },
      overrideStrings: {
        allItemsAreSelected: "All Members",
        selectAll: "All Members",
        selectSomeItems: "Choose shift members"
      }
    }))), /*#__PURE__*/React.createElement(Row, {
      className: "add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "shift-time-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      className: "shift-time-delete-cancel-button",
      onClick: handleClose
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "shift-time-modal-save-button",
      type: "submit",
      disabled: modalType == "AddShift" ? addShiftTimeLoading : editShiftTimeLoading
    }, addShiftTimeLoading || editShiftTimeLoading ? "Loading..." : modalType == "AddShift" ? "Create Shift" : "Update Shift"))))))));
  })));
};
var DeleteShiftModal = function DeleteShiftModal(props) {
  var showDeleteModal = props.showDeleteModal,
    handleDeleteClose = props.handleDeleteClose,
    timeZone = props.timeZone,
    role = props.role,
    teamId = props.teamId;
  if (showDeleteModal === null) {
    return null;
  }
  var _useMutation5 = useMutation(DELETE_SHIFT_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    deleteShiftTime = _useMutation6[0],
    deleteShiftLoading = _useMutation6[1].loading;
  var handleDeleteTeam = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!deleteShiftLoading) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            _context5.next = 4;
            return deleteShiftTime({
              variables: {
                shiftId: showDeleteModal.shiftId,
                organisationId: showDeleteModal.organisationId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_SHIFT_DETAILS_QUERY,
                variables: {
                  organisationId: showDeleteModal.organisationId,
                  timeZone: timeZone,
                  limit: LIST_LIMIT,
                  offset: 0
                }
              }, {
                query: SHIFT_USER_LISTING_QUERY,
                variables: {
                  organisationId: showDeleteModal.organisationId,
                  teamId: teamId,
                  userRole: role
                }
              }]
            });
          case 4:
            response = _context5.sent;
            if (!(!response || !response.data || response.data.deleteShiftTime === null)) {
              _context5.next = 9;
              break;
            }
            throw new Error("error");
          case 9:
            handleDeleteClose();
            toast.success("Shift deleted successfully!");
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
  }, [deleteShiftTime, deleteShiftLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showDeleteModal,
    onHide: handleDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete shift Time")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, "Are you sure you want to delete", " ", /*#__PURE__*/React.createElement("span", {
    className: "manage-teams-edit-menus-delete-icon-name"
  }, showDeleteModal.shiftName, "?"))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDeleteTeam("inactive"),
    disabled: showDeleteModal.teamDeleteStatus ? true : false
  }, deleteShiftLoading ? "Loading..." : "Delete")));
};
export default ShiftTime;